import {
	BarController,
	BarElement,
	CategoryScale,
	Chart,
	Filler,
	LinearScale,
	LineController,
	LineElement,
	PointElement,
	Tooltip,
} from "chart.js";
import { Widget } from "@foretagsplatsen/widgetjs";

Chart.register(
	BarController,
	BarElement,
	CategoryScale,
	Filler,
	LineController,
	LineElement,
	LinearScale,
	PointElement,
	Tooltip,
);

/**
 * Render a chart. The x-axis is for time labels. The
 * `chartStrategy` configure the chart options and
 * determine the height of points or bars based on `values`.
 *
 * @param {Map<object, object[]>} values - The key object will be used
 *   by the strategy to deduct the series name where the value will
 *   be used to deduct the series values.
 * @param {string} [height] - The amount of vertical space the widget
 *   should take in pixel
 * @param {AbstractChartStrategy} chartStrategy - Strategy pattern
 *   class to build the chart options
 * @param {string} [dataTestName] - A string to be used to find the chart with the test framework
 */
export default class ChartWidget extends Widget {
	constructor({
		values,
		height,
		chartStrategy: chartStrategy,
		dataTestName,
	}) {
		super(...arguments);

		this._values = values;
		this._height = height;
		this._chartStrategy = chartStrategy;
		this._dataTestName = dataTestName;
	}

	renderContentOn(html) {
		const canvas = html.canvas({ height: this._height });

		this._drawOnCanvas(canvas.element);
	}

	_renderRootOn(html) {
		return html.div({
			id: this.getId(),
			"data-test": this._dataTestName,
			class: ["ChartWidget", this._chartStrategy.getCssClass()],
		});
	}

	_drawOnCanvas(canvas) {
		const context = canvas.getContext("2d");

		return new Chart(
			context,
			this._chartStrategy.getConfiguration({
				context,
				values: this._values,
			}),
		);
	}
}
